<template>
	<section>

	<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
			    <el-form-item>
					<el-input v-model="filters.title" placeholder="摘要"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getInfos">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary"  size="medium" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="infos" border stripe highlight-current-row v-loading="listLoading" @sort-change="sortChange"
		 style="width: 100%;" :header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<!--
			<el-table-column type="selection"  min-width="40">
			</el-table-column>
			-->
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>			
			<el-table-column prop="group_name" label="产品组"  width="80">
			</el-table-column>
			<el-table-column prop="app_name" label="产品"  width="80">
			</el-table-column>			
			<el-table-column prop="title" label="摘要" width="200" >
			</el-table-column>	
			
			<el-table-column prop="maker_name" label="创建人" width="80" >
			</el-table-column>
			<el-table-column prop="make_date" label="创建时间" width="180" >
			</el-table-column>
			<el-table-column label="操作" min-width="140">
				<template slot-scope="scope">
					<el-button type="primary" size="small"  plain @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" :disabled="scope.row.sender==null?false:true" plain @click="handleDel(scope.$index, scope.row)">删除</el-button>
					<el-button type="primary" size="small" :disabled="scope.row.sender==null?false:true" plain @click="handleSend(scope.$index, scope.row)">发布确认</el-button>
					<el-button type="danger" size="small" :disabled="scope.row.sender==null?true:false"  plain @click="handleCancel(scope.$index, scope.row)">撤销</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>--></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[20, 50, 80, 100]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false"  width="70%">
			<el-form :model="editForm"    label-width="120px" :rules="editFormRules" ref="editForm">
			   	<el-form-item label="产品组" prop="app_group">
					 <el-select v-model="editForm.app_group"   placeholder="请选择" @change="appGroupChange"  @visible-change="visibleChange"  style="width:400px;">
                        <el-option  v-for="(item,index) in appgroups" :key="index"  :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				</el-form-item>

				<el-form-item label="产品" prop="app_id">
					 <el-select v-model="editForm.app_id"   placeholder="请选择" style="width:400px;">
                        <el-option  v-for="(item,index) in apps" :key="index"  :label="item.app_name"  :value="item.id"> </el-option>
                     </el-select>
				</el-form-item>

				 <el-form-item label="摘要" prop="title" >
					<el-input v-model="editForm.title" auto-complete="off"></el-input>
				 </el-form-item>
			
			</el-form>

          	<div style="margin:2px 0px 6px 0px;">
					<el-button type="primary" @click="showSentence">添加例句</el-button>
			</div>

			<el-dialog width="70%" title="选择例句" :visible.sync="innerVisible" append-to-body>
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="sentencefilters">
						<el-form-item>
							<el-input v-model="sentencefilters.word" placeholder="单词"></el-input>
						</el-form-item>
						<el-form-item>
							<el-input v-model="sentencefilters.english" placeholder="例句"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="querySentence">查询</el-button>
						</el-form-item>
					</el-form>				
				</el-col>
             
				<!--列表-->
				<el-table :data="sentences"  height="350" border stripe highlight-current-row v-loading="sentencelistLoading" @selection-change="selsChange" @sort-change="sentenceSortChange"
				style="width: 100%;" :header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
					
					<el-table-column type="selection"  min-width="40">
					</el-table-column>
					<!--
					    <el-table-column type="index" label="编号"  width="80">
					    </el-table-column>	
					-->		
					<el-table-column prop="word" label="单词"  width="150">
					</el-table-column>
					<el-table-column prop="part_of_speech" label="词性"  width="80">
					</el-table-column>			
					<el-table-column prop="english" label="例句" width="200" >
					</el-table-column>						
					<el-table-column prop="chinese" label="解释" width="200" >
					</el-table-column>
					<el-table-column prop="source" label="出处" >
					</el-table-column>
				</el-table>

				<!--工具条-->
			       <div  class="toolbar">
						<el-pagination @size-change="handleSentenceSizeChange"  @current-change="handleSentenceChange" :current-page="sentencePage"
									:page-sizes="[20, 50, 80, 100]" :page-size="sentenceSize"  layout="total, sizes, prev, pager, next, jumper" :total="sentenceTotal">
						</el-pagination>
			        </div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="innerVisible=false;">取 消</el-button>
						<el-button type="primary" @click="hideSentence">确 定</el-button>
					</span>
            </el-dialog>
			
			<el-table :data="sentenceData" height="350" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange"
				style="width: 100%;" :header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
				<el-table-column prop="english" label="英文" width="250"></el-table-column>
				<el-table-column prop="chinese" label="中文" width="200"></el-table-column>
				<el-table-column prop="source" label="出处"></el-table-column>
				<el-table-column label="操作" min-width="140">
					<template slot-scope="scope">
						   <el-button  @click.native.prevent="deleteRow(scope.$index, sentenceData)" type="text"  size="small">移除</el-button>
					</template>
			   </el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false;">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

	
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getMainListPage,getSubListPage,getSentenceListPage,addSentence,editSentence, removeSentence,batchRemoveSentence,getAppGroup,getApp,sentenceRelease,sentenceUnRelease } from '../../api/api';
 
 let CurrentUserID="",Session=""; 
 
	export default {
		data() {
			return {
				filters: {
					title: ''
				},
				sentencefilters:{
					word:'',
					english:''
				},	
				innerVisible:false,
				appgroups:[],
				apps:[],							
				infos: [],
				sentences: [],
				sentenceData:[],
				total: 0,
				pageSize:20,
				currentPage: 1,
				sentenceTotal:0,
				sentenceSize:20,
                sentencePage:1,
				listLoading: false,
				sentencelistLoading: false,
				sels: [],//列表选中列
                prop:"", 
				order:"",
				sentenceprop:"", 
				sentenceorder:"",
				editFormVisible:false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					app_group: [
						{ required: true, message: '请选择产品组', trigger: 'change' }
					],
					app_id:[ {  required: true, message: '请选择产品', trigger: 'change' }]
					
				},							
				//编辑界面数据
				editForm: {
					id: 0,							
					app_group:'',
					app_id:'',        
				},				
				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
 		    handleSizeChange(val) {
				this.pageSize=val;                 
				this.getInfos();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getInfos();
			},   

			handleSentenceSizeChange(val) {
				
				this.sentenceSize=val;                 
				this.getSentence();
				this.setselect();

		
				
             },		
			handleSentenceChange(val) {
				
				this.sentencePage = val;
				this.getSentence();
				this.setselect();
			},  
            showSentence()
			{
				this.innerVisible = true;
				this.getSentence();
			},
			hideSentence()
			{
				this.innerVisible = false;
				this.setselect();
			},
			setselect()
			{				
              	var a = this.sentenceData.concat(this.sels);

				for(var i=0; i<a.length-1;i++)
				{
					for(var j=i+1; j<a.length;j++)
					{
						if(a[i].example_id == a[j].example_id)
						{
							
						   a.splice(j, 1);
						  
						}
					}
				}
				/*var res = [];
				var json = {};
				for(var i = 0; i < a.length; i++){
					if (!json.hasOwnProperty(a[i]))
					{
						res.push(a[i]);
						json[a[i]] = 1;
					}
				}*/
              
				this.sentenceData=a;
                this.sels=[];
			} ,     
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },

			visibleChange(val)
			  {
                 if(val)
				 {
                      this.selectchangeflag=1;
				 }else{
                       this.selectchangeflag=0;
				 }
			  },
			removeTag(val)
			  {
                  this.selectchangeflag=1;
			  },
			appGroupChange(val)
				{   
					if (this.selectchangeflag==0) return;
					this.editForm.app_id='';
					if (val==''  ) return;				   				
				    this.getApp(val);  

				},
			
			getApp(val){
					this.$http.jsonp(getApp,{params: {CurrentUserID:CurrentUserID,Session:Session,appGroup:val}}).then(
						function(res){                         
							if (res.data.result_code==200)
							{						
								this.apps=res.data.apps;								
							    
								
							}
							else{                           
								this.$message({
								message:'获取产品错误',
								type: 'error'
								});
							}					

						},
						function(res){
							this.$message({
									message:'获取产品错误',
									type: 'error'
									}
							);
								
						}
					);

				},

		   getAppGroup(){
             	this.$http.jsonp(getAppGroup,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
						if (res.data.result_code==200)
						{						
							this.appgroups=res.data.appgroups;					
						}
						else{                           
							this.$message({
							message:'获取产品组错误',
							type: 'error'
							});
						}				

					},
					function(res)
					{
						this.$message({
								message:'获取产品组错误',
								type: 'error'
								}
						);
						
					}
				);
			},
			getInfos() {
				let para = {					
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					title: this.filters.title,					
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;				

            this.$http.jsonp(getMainListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.infolist.total;
					         this.infos = res.data.infolist.infos;
					         this.listLoading = false;
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   }
           )

			},
            querySentence() {
				this.sentencePage = 1;
				this.getSentence();
			},
			getSentence:function(){
                               
				 let para = {
					appID:this.editForm.app_id,
					CurrentUserID:CurrentUserID,					
				    currentPage: this.sentencePage,
					pageSize:this.sentenceSize,
					word: this.sentencefilters.word,
					english: this.sentencefilters.english,						
					sortName:this.sentenceprop,
					sortOrder:this.sentenceorder,
					Session:Session
				};
				this.sentencelistLoading = true;				

            this.$http.jsonp(getSentenceListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.sentenceTotal = res.data.infolist.total;
					         this.sentences = res.data.infolist.infos;
					         this.sentencelistLoading = false;
                           
                         }
                         else{                           
                              
                             this.sentencelistLoading = false;
							 
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.sentencelistLoading = false;
                   }
           )

			},
			//删除
			handleDel: function (index, row) {

				if (row.sender!=null)
				{
                    this.$message({
                                message:'已确认发布，不能删除！',
                                type: 'warning'
                              });
					return;

				}
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };


                   this.$http.jsonp(removeSentence, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
		    //发布
			handleSend: function (index, row) {
				if (row.sender!=null)
				{
                    this.$message({
                                message:'已发布！',
                                type: 'warning'
                              });
				     return;
				}

				this.$confirm('确认发布吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };

                   this.$http.jsonp(sentenceRelease, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '发布成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//撤销发布
			handleCancel: function (index, row) {
				if (row.sender==null)
				{
                    this.$message({
                                message:'未发布，不能撤销！',
                                type: 'warning'
                              });
				     return;
				}

				this.$confirm('确认撤销吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };

                   this.$http.jsonp(sentenceUnRelease, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '撤销成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:res.data.error,
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				
				this.formStatus=1;				
				this.selectchangeflag=0;				
				this.editForm = Object.assign({}, row); 
				this.getApp(this.editForm.app_group);
				this.editFormVisible = true;
				let para = {
					CurrentUserID:CurrentUserID,					
				    currentPage: this.sentencePage,
					id:	row.id,				
					Session:Session};
				 this.$http.jsonp(getSubListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 
					         this.sentenceData = res.data.infolist.infos;
					         this.sentencelistLoading = false;
                           
                         }
                         else{                           
                              
                             this.sentencelistLoading = false;
							 
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.sentencelistLoading = false;
                   }
           )


      			
				
			},
			//显示新增界面
			handleAdd: function () {				
				this.formStatus=0;				
				this.editFormVisible = true;
				this.editForm = {
					id: 0,								
					app_group:'',
					app_id:'',					
					title:''           
				};
				this.sentenceData=[];
				this.sentenceTotal=0;
				this.sentenceSize=20;
                this.sentencePage=1;
				this.sels=[];
				this.sentences=[];
				
               if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				
			},
			//编辑
			editSubmit: function () {

				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							  
                                                  			         

							let para = Object.assign({}, this.editForm);
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;
							para["Sentence"]=this.sentenceData;
		


			   let infoUrl=	addSentence;			  
               if (this.formStatus==1)
			   {
                  infoUrl=editSentence;
			   }
                //this.$http.jsonp(infoUrl, {params: para}).then(
				this.$http.post(infoUrl, para,{emulateJSON:false}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {		
							// this.$refs['editForm'].resetFields();	
							this.editForm = {
								id: 0,									
								app_group:'',
								app_id:'',					
								title:''         
							};	

							this.sentenceData=[];
							this.sentenceTotal=0;
							this.sentenceSize=20;
							this.sentencePage=1;
							this.sels=[];
							this.sentences=[];	
							    	    
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getInfos();
                            
                         }
                         else{                           
                               this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:res.data.error,
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
							  this.editLoading = false;	
                      
                   }
           )


						});
					}
				});
			},

			selsChange: function (sels) {
				this.sels = sels;

			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getInfos();
			},

			sentenceSortChange:function(order){
				this.sentenceprop=order.prop;
				this.sentenceorder=order.order,
				this.getsentence();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					
					let para = { ids: ids,CurrentUserID:CurrentUserID,Session:Session };
            

                   this.$http.jsonp(batchRemoveSentence, {params: para}).then(
                   function(res){                         
						if (res.data.result_code==200)
						{
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
							});
							this.getInfos();
						
						}
						else{                      
							
							this.listLoading = false;

							if (res.data.result_code==911)
							{
								this.$router.push({ path: "/login"});
								return;
							}

							if (res.data.result_code==600)
							{
									this.$message({
										message:'接口错误',
										type: 'error'
									});
								return;
							}
							if  (res.data.result_code==914)
							{
								this.$message({
								message:'没有删除权限',
								type: 'error'
								});
								return;
							}
						}
                    },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 					
			this.getAppGroup();
			this.getInfos();	        
			
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// pushSentenceList.vue?5d2be258